import { useEffect, useState } from 'react';

export default function useWindowHeight(parent?: HTMLElement | null) {
    function calcHeight() {
        // https://bugzilla.mozilla.org/show_bug.cgi?id=156388#c14
        const viewPortHeight = document.documentElement.clientHeight;
        // console.info('calcHeight', viewPortHeight, parent ? parent.offsetTop : 'no parent');
        return parent ? viewPortHeight - parent.offsetTop : viewPortHeight;
    }

    const [height, setHeight] = useState(calcHeight);

    useEffect(() => {
        setHeight(calcHeight());
        const onResize = () => setHeight(calcHeight());
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, [parent]);

    return height;
}
